export default {
  'compare-mobile': {
    apiUrl: '/api/v1/intelligence_pc/topChartMobileMetricExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['appannie', 'sensortower'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['dau', 'revenue', 'download'],
        options: [
          { label: 'Active Users', value: 'dau' },
          { label: 'Revenue', value: 'revenue' },
          { label: 'Downloads', value: 'download' },
        ],
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          company_show: false,
          genre_show: false,
          release_date_show: false,
          region_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
          { label: 'dbi_release_date', value: 'release_date_show' },
          { label: 'dbi_area_region', value: 'region_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },

          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
  'compare-mobile-store-rank': {
    apiUrl: '/api/v1/intelligence_pc/detail/stats/metrics/store_rank/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'source_type',
        defaultValue: ['app_store', 'google_play'],
        options: [
          { label: 'App Store', value: 'app_store' },
          { label: 'Google Play', value: 'google_play' },
        ],
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: '',
        defaultValue: {
          company_show: false,
          genre_show: false,
          // release_date_show: false,
          // region_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
          // { label: 'dbi_release_date', value: 'release_date_show' },
          // { label: 'dbi_area_region', value: 'region_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'date_method',
            message: '',
            options: [
              // { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              // { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },

          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
};
